import {getAbsoluteUrl} from "../../utils/urlUtill";
import {SCHEDULES_API_URL} from "../const/schedulesConst";

export class SchedulesService {

    constructor($http) {
        this.$http = $http;
    }

    getSchedules() {
        return this.$http({method: 'GET', url: getAbsoluteUrl(SCHEDULES_API_URL)});
    }

    deleteTrigger(scheduleId, triggerId) {
        return this.$http({
            method: 'DELETE',
            url: getAbsoluteUrl(`${SCHEDULES_API_URL}/task/${scheduleId}/trigger/${triggerId}`)
        });
    }

    saveTrigger(schedule, trigger) {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl(`${SCHEDULES_API_URL}/task/${schedule.id}/trigger`),
            data: trigger
        });
    }

    executeNow = (scheduleId) => {
        return this.$http({
            method: 'POST',
            url:getAbsoluteUrl(`${SCHEDULES_API_URL}/${scheduleId}?execute_now=true`)
        })
    };

    pullNextDates(trigger) {
        return this.$http({method: 'POST', url: getAbsoluteUrl(`${SCHEDULES_API_URL}/future`), data: trigger})
    }

    saveSchedule(schedule) {
        return this.$http({method: 'POST', url: getAbsoluteUrl(SCHEDULES_API_URL), data: schedule});
    }
}